module.exports = __webpack_public_path__ + "static/media/items-page.f15217bb.png";